/* eslint-disable no-irregular-whitespace */
import PropTypes from 'prop-types';
import Figure from '../../Figure/Figure';

// Import des images résultat politique
import politique_desktop from "../../../assets/img/results/banniere/desktop/POLITIQUE_00_Banniere_RESIZED_75.webp";
import politique_mobile from "../../../assets/img/results/banniere/mobile/POLITIQUE_00_Banniere_RESIZED_75.webp";

// Import des images résultat intime
import intime_desktop from "../../../assets/img/results/banniere/desktop/INTIME_00_Banniere_RESIZED_75.webp";
import intime_mobile from "../../../assets/img/results/banniere/mobile/INTIME_00_Banniere_RESIZED_75.webp";

// Import des images résultat festive
import festive_desktop from "../../../assets/img/results/banniere/desktop/11_1980_Breakdance_2000_75.webp";
import festive_mobile from "../../../assets/img/results/banniere/mobile/11_1980_Breakdance_600_75.webp";

function ResultCase({ type }) {
    let content = '';
    switch (type) {
        case 'politique':
            content = <PolitiqueCase />;
            break;
        case 'intime':
            content = <IntimeCase />;
            break;
        case 'festive':
            content = <FestiveCase />;
            break;
        default:
            content = <PolitiqueCase />;
    }

    return content;
}

ResultCase.propTypes = {
    type: PropTypes.string.isRequired
}

export default ResultCase;

function PolitiqueCase() {
    return (
        <>
            <div className="quiz-progress">
                <p>
                    votre radio est
                </p>
            </div>
            <h1>
                <span className="sr-only">votre radio est politique</span>
                <span aria-hidden="true">politique</span>
            </h1>
            <Figure
                className="desktop-col-start--1 desktop-col-end--15 mobile-col-start--1 mobile-col-end--7 quiz-figure quiz-figure--1 quiz-figure--introduction"
                medias={{'desktop': politique_desktop, 'mobile': politique_mobile}}
                hasCreditsPopin={true}
                credits={<><p>Etudiants dans la manifestation du 13 mai 68 à Paris.</p><p>&copy; Keystone-France/Gamma-Rapho via Getty Images</p></>}
                hasCaption={false} />
            <p>
                C’est un outil collectif de libération et de lutte contre l’oppression. Le matin,
                vous « n’écoutez » pas seulement les infos. Vous les commentez, partagez, applaudissez,
                râlez, pleurez. C’est votre façon de vous réveiller.
            </p>
            <p>
                Vous avez des humoristes préférés dont vous ne ratez JA-MAIS les chroniques,
                quitte à les écouter en différé.
            </p>
            <p>
                Votre pire cauchemar ? Qu’ils se fassent virer.
            </p>
        </>
    )
}

function FestiveCase() {
    return (
        <>
            <div className="quiz-progress">
                <p>
                    votre radio est
                </p>
            </div>
            <h1>
                <span className="sr-only">votre radio est festive</span>
                <span aria-hidden="true">festive</span>
            </h1>
            <Figure
                className="desktop-col-start--1 desktop-col-end--15 mobile-col-start--1 mobile-col-end--7 quiz-figure quiz-figure--1 quiz-figure--introduction"
                medias={{'desktop': festive_desktop, 'mobile': festive_mobile}}
                hasCreditsPopin={true}
                credits={<><p>Breakdance à Marseille, années 90.</p><p>&copy; Photo by Jean-Erick PASQUIER/Gamma-Rapho via Getty</p></>}
                hasCaption={false} />
            <p>
                Vous êtes pas venu.e là pour souffrir ok ? Des sons incroyables,
                des basses démesurées, la radio c’est surtout fait pour danser.
            </p>
            <p>
                Les algorithmes vous détestent. Toujours à la recherche d’un son nouveau,
                d’un artiste émergeant, d’un mix inédit, vous les épuisez !
            </p>
            <p>
                Pas question d’écouter la même chanson 7 fois dans la journée ou alors,
                en mode privé.
            </p>
            <p>
                Il faudrait pas abimer son wrapped, c’est vrai.
            </p>
        </>
    )
}

function IntimeCase() {
    return (
        <>
            <div className="quiz-progress">
                <p>
                    votre radio est
                </p>
            </div>
            <h1>
                <span className="sr-only">votre radio est intime</span>
                <span aria-hidden="true">intime</span>
            </h1>
            <Figure
                className="desktop-col-start--1 desktop-col-end--15 mobile-col-start--1 mobile-col-end--7 quiz-figure quiz-figure--1 quiz-figure--introduction"
                medias={{'desktop': intime_desktop, 'mobile': intime_mobile}}
                hasCreditsPopin={true}
                credits={<><p>Écoute au casque dans les transports en commun.</p><p><a target="_blank" className="link link--external" href="https://www.gettyimages.fr/search/filmmaker?filmmaker=Counter">&copy; Counter/Getty Images</a></p></>}
                hasCaption={false} />
            <p>
                Les peines, les discriminations, les trouvailles, les rébellions,
                on en parle ? Où ? Grâce à la radio : partout.
            </p>
            <p>
                C’est ça que vous aimez. Qu’elle porte les voix, les cris, les
                idées jusqu’à vous.
            </p>
            <p>
                Dans votre métro, au rayon surgelés, dans la chambre, sur le canapé... Il
                vous suffit d’une paire d’écouteurs, d’une enceinte connectée et c’est
                le monde d’un autre auquel vous accédez. Un autre, oui, mais après
                l’avoir écouté, étrangement familier.
            </p>
        </>
    )
}
